import type { FC } from "react";

import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { Txt } from "@jti/ui";

import styles from "./ProductDescription.module.scss";

const { sanitize } = dompurify;

type VisibleOn = "all" | "mobile" | "desktop";

type Props = {
  description: string;
  visibleOn?: VisibleOn;
};

export const ProductDescription: FC<Props> = ({ description, visibleOn = "desktop" }) => {
  return (
    <Txt variant="txt-1">
      <div
        className={classNames(styles.description, styles[visibleOn])}
        dangerouslySetInnerHTML={{ __html: sanitize(description) }}
      />
    </Txt>
  );
};
